import { z } from 'zod';
import { TIME_STRICT_REGEX } from '@/utils/timeConversion';


const positiveIntegerStringValidator = (value: string): boolean => {
  const num = Number(value);
  return Number.isFinite(num) && Number.isInteger(num) && num > 0;
};

export const manualAttendanceFormSchema = z.object({
  employeeId: z.string()
    .min(1, 'attendance:manual.validation.employeeRequired')
    .refine(positiveIntegerStringValidator, { message: 'attendance:manual.validation.employeeRequired' }),
  locationId: z.string()
    .min(1, 'attendance:manual.validation.locationRequired')
    .refine(positiveIntegerStringValidator, { message: 'attendance:manual.validation.locationRequired' }),
  attendanceDate: z.string()
    .min(1, 'attendance:manual.validation.dateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'attendance:manual.validation.invalidDateFormat'),
  attendanceTime: z.string()
    .min(1, 'attendance:manual.validation.timeRequired')
    .regex(TIME_STRICT_REGEX, 'attendance:manual.validation.invalidTimeFormat'),
  notes: z.string()
    .trim()
    .min(1, 'attendance:manual.validation.notesRequired')
    .max(100, 'attendance:manual.validation.notesMaxLength'),
});

export type ManualAttendanceFormValues = z.infer<typeof manualAttendanceFormSchema>;
